module.exports = __webpack_public_path__ + "img/trophy.245282d5.gif";